import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class SmartPricingRulesManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/smart-pricing-rules',
      params,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/smart-pricing-rules/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/smart-pricing-rules',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/smart-pricing-rules/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/smart-pricing-rules/${id}`,
    });

  bulkDelete = (params) =>
    this.request({
      method: 'DELETE',
      url: '/smart-pricing-rules/bulk',
      params,
      paramsSerializer: qs.stringify,
    });

  uploadImage = (id, data) =>
    this.request({
      method: 'POST',
      url: `/smart-pricing-rules/${id}/images`,
      data,
    });

  deleteImage = (id, data) =>
    this.request({
      method: 'DELETE',
      url: `/smart-pricing-rules/${id}/images`,
      data,
    });

  generateImage = (id) =>
    this.request({
      method: 'POST',
      url: `/smart-pricing-rules/${id}/images/generate`,
    });
}
